import { inject, Injectable, Injector } from '@angular/core';
import { getAppName, getCompanyHeader } from '@lx/shared/tokens';
import { DataLayerErrorEventType, GoogleAnalyticsErrorEventType } from '../types/google-analytics-error-event.type';
import { DATA_LAYER_ERROR_EVENT_TYPE } from '../tokens/data-layer.token';

declare const window: Window & { dataLayer: GoogleAnalyticsErrorEventType[] };

/**
 * Service to track errors in Google Analytics
 */
@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsErrorsService {
  private readonly company = getCompanyHeader();
  private readonly appName = getAppName();
  private readonly errorEventType = inject(Injector).get(DATA_LAYER_ERROR_EVENT_TYPE, DataLayerErrorEventType.error);

  constructor() {
    window.dataLayer = window.dataLayer || [];
  }

  trackEvent(errorMessage: string) {
    const event = {
      event: this.errorEventType,
      company: this.company,
      appName: this.appName,
      browserAgent: window.navigator.userAgent,
      url: window.location.href,
      message: errorMessage,
    };
    window.dataLayer.push(event);
  }
}
